import { Badge } from "reactstrap";
import { DesignLearnig, Href } from "../../../../../Constant";
import { LI, UL } from "../../../../../AbstractElements";
import { DESIGN_CATEGORT_DATA } from "../../../../../Data/Learning";
import { Link } from "react-router-dom";

const DesignCategories = () => {
  return (
    <div className="categories pt-2">
      <div className="learning-header">
        <span className="f-w-700">{DesignLearnig}</span>
      </div>
      <UL>
        {DESIGN_CATEGORT_DATA.map((data, index) => (
          <LI className="border-0" key={index}>
            <Link to={Href}>{data.learningHeading}</Link>
            <Badge color="primary" className="pull-right">{data.badgeNumber}</Badge>
          </LI>
        ))}
      </UL>
    </div>
  );
};

export default DesignCategories;
